<template>
  <div>
    Assurance Bien
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'AssuranceBien'
}
</script>
